import { Entity } from '@api/api/entity-schema';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import styles from '@terminal/widgets/company-to-theme-widget/CompanyToThemeWidget.module.scss';

import { CountryExposureDrawerContent } from './tabs/country-exposure-tab/CountryExposureDrawerContent';
import { RegionExposureDrawerContent } from './tabs/region-exposure-tab/RegionExposureDrawerContent';

export interface CompanyToGeoWidgetProps {
  entity: Entity;
}

export const CompanyToGeoWidget = ({ entity }: CompanyToGeoWidgetProps) => {
  const { params } = useQueryParams();
  const countryCode = params[queryKeys.countryCode];

  return (
    <div className={styles.container}>
      <ErrorBoundaryWrapper>
        {countryCode ? (
          <CountryExposureDrawerContent entity={entity} />
        ) : (
          <RegionExposureDrawerContent entity={entity} />
        )}
      </ErrorBoundaryWrapper>
    </div>
  );
};
